import React, { useState } from 'react';
import { FileText, ChevronRight, Search, Book } from 'lucide-react';
import LIBRARY_DATA from '../data/library.json';

const AvailableFiles = ({ onFileSelect }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredFiles = LIBRARY_DATA.filter(file =>
    file.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    file.year.includes(searchTerm)
  );

  return (
    <div className="flex flex-col h-full">
      <div className="relative px-2 mb-4">
        <Search className="absolute left-5 top-2.5 text-gray-400" size={16} />
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search acts..."
          className="w-full pl-9 pr-4 py-2 bg-white border border-gray-200 rounded-lg text-sm focus:outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 transition-all"
        />
      </div>

      <div className="flex-grow overflow-y-auto space-y-2 px-1">
        {filteredFiles.length === 0 && (
          <div className="text-center py-8 text-gray-400 text-sm">
            No files found
          </div>
        )}

        {filteredFiles.map(file => (
          <div
            key={file.id}
            onClick={() => onFileSelect(file)}
            className="group p-3 rounded-xl border border-transparent hover:border-gray-200 hover:bg-white cursor-pointer transition-all"
          >
            <div className="flex items-start justify-between mb-1">
              <div className="flex items-center gap-2">
                <div className="p-1 bg-gray-100 text-gray-500 rounded group-hover:bg-blue-50 group-hover:text-blue-600 transition-colors">
                  <Book size={14} />
                </div>
                <div className="font-medium text-gray-900 text-sm line-clamp-2">{file.title}</div>
              </div>
              <ChevronRight size={16} className="text-gray-300 group-hover:text-blue-500 transition-colors flex-shrink-0" />
            </div>
            <div className="flex items-center gap-2 text-xs text-gray-500 ml-7">
              <span className="bg-gray-100 px-1.5 py-0.5 rounded text-gray-600">{file.year}</span>
              <span>{file.jurisdiction}</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AvailableFiles;